import * as React from "react";
const SvgFiRrSplotch = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-splotch_svg__a)">
      <path
        fill="#062147"
        d="M20.909 8.796c-.541-.405-1.052-.788-1.352-1.125-.305-.345-.363-2.01-.398-3.005-.073-2.097-.142-4.078-1.585-4.56-1.258-.415-2.541.425-3.897 1.32-1.04.686-2.22 1.464-3.286 1.58-.939.107-2.162-.39-3.337-.868-1.773-.723-3.608-1.471-5.082-.364-1.846 1.384-.796 3.609.048 5.397.543 1.153 1.105 2.345.989 3.194-.143 1.045-.771 1.785-1.435 2.569C.836 13.804 0 14.79 0 16.19c0 2.494 2.45 2.678 4.238 2.813 1.206.09 2.453.185 3.437.694 1.077.559 1.677 1.338 2.257 2.092.797 1.036 1.699 2.21 3.64 2.21 1.794 0 2.412-2.16 3.011-4.25.259-.904.581-2.03.885-2.378.28-.321 1.452-.715 2.308-1.003 1.98-.667 4.226-1.422 4.226-3.321 0-1.936-1.714-3.22-3.091-4.251zm-1.773 5.677c-1.362.458-2.539.855-3.176 1.583-.597.685-.938 1.878-1.301 3.142-.26.908-.744 2.598-1.088 2.8-.917 0-1.292-.438-2.055-1.43-.646-.84-1.449-1.885-2.922-2.647-1.346-.697-2.865-.812-4.206-.913-2.193-.165-2.389-.345-2.389-.818 0-.634.418-1.16 1.1-1.963.743-.877 1.669-1.968 1.892-3.591.196-1.438-.495-2.902-1.163-4.32C3 4.563 2.708 3.72 3.171 3.374c.146-.11.341-.156.569-.156.664 0 1.623.39 2.559.772 1.339.545 2.853 1.164 4.311 1.005 1.545-.17 2.938-1.088 4.169-1.9.634-.417 1.664-1.097 2.079-1.102.223.43.272 1.866.304 2.743.061 1.738.118 3.379.9 4.26.434.49 1.023.933 1.648 1.4 1.073.805 2.29 1.716 2.29 2.65 0 .463-2.007 1.139-2.864 1.428"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-splotch_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrSplotch;
